export const isSticky = (e) => {
  const body = e.target.body;
  const header = body.querySelector(".is-sticky");
  header.classList.add("sticky");
};
